import React from 'react';
import styled from 'styled-components';

const MetaWrapper = styled.div`
  display: flex;
  ${ (props) => props.align === 'center' ? 'justify-content: center;' : null };
  align-items: center;
`;

const MetaAvatarWrapper = styled.div`
  display: inline-block;
  flex-shrink: 0;
  height: 24px;
  width: 24px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 8px;
`;

const MetaAvatar = styled.img`
  max-width: 100%;
`;

const MetaName = styled.span`
  font-size: 14px;
  font-style: normal;
  color: #858c9a;
  ${props => props.size === 'large' ? 'font-size: 16px;' : null}
`;

export const Meta = props => {
  return (
    <MetaWrapper
      align={props.align}
      space={props.space}
    >
      <MetaAvatarWrapper>
        <MetaAvatar src={props.avatar} />
      </MetaAvatarWrapper>
      <div>
        <MetaName
          size={props.size}
        >
          {props.name}
          {' '}on {props.date}
        </MetaName>
      </div>
    </MetaWrapper>
  );
}


// WEBPACK FOOTER //
// ./src/components/Meta/index.js